import {Component, Input} from '@angular/core';
import {ModalControllerService} from '../../../../shared/shared-services/overlay/modal-controller.service';
import {IconsEnum} from '../../../shared-icons/models/icons.enum';

@Component({
  selector: 'app-modal-header',
  templateUrl: './modal-header.component.html',
  styleUrls: ['./modal-header.component.scss'],
  standalone: false,
})
export class ModalHeaderComponent {
  @Input() title: string;
  @Input() close: () => void;
  @Input() hideClose?: boolean = false;
  icons = IconsEnum;

  constructor(private modalController: ModalControllerService) {
  }
}
